module.exports = __webpack_public_path__ + "Participant Notice 8_2_2024.pdf";